// extracted by mini-css-extract-plugin
export default {"ring":"style_gradient_background_ring__2wI+F","dot":"style_gradient_background_dot__6JMwX","hovered":"style_gradient_background_hovered__Q1fiV"};